var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.total > 1
    ? _c(
        "nav",
        {
          staticClass: "oc-pagination",
          attrs: { "aria-label": "Page navigation" }
        },
        [
          _c(
            "ul",
            { staticClass: "ordercall-pagination" },
            [
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "inline-link",
                    attrs: { disabled: _vm.currentPage == 1, href: _vm.url },
                    on: {
                      click: function($event) {
                        return _vm.setPage(+_vm.currentPage - 1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "oc-icon16 ico-arrow-left" })]
                )
              ]),
              _vm._v(" "),
              _c("li", { class: { selected: _vm.currentPage == 1 } }, [
                _c(
                  "a",
                  {
                    staticClass: "inline-link",
                    attrs: { href: _vm.url },
                    on: {
                      click: function($event) {
                        return _vm.setPage(1)
                      }
                    }
                  },
                  [_vm._v("1")]
                )
              ]),
              _vm._v(" "),
              _vm.currentPage - 1 > 2 && _vm.total > 5
                ? _c("li", [_c("span", [_vm._v("...")])])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.pages, function(page) {
                return _c(
                  "li",
                  { key: page, class: { selected: page == _vm.currentPage } },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.url },
                        on: {
                          click: function($event) {
                            return _vm.setPage(page)
                          }
                        }
                      },
                      [_vm._v(_vm._s(page))]
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _vm.total - _vm.currentPage > 2 && _vm.total > 5
                ? _c("li", [_c("span", [_vm._v("...")])])
                : _vm._e(),
              _vm._v(" "),
              _c("li", { class: { selected: _vm.currentPage == _vm.total } }, [
                _c(
                  "a",
                  {
                    staticClass: "inline-link",
                    attrs: { href: _vm.url },
                    on: {
                      click: function($event) {
                        return _vm.setPage(_vm.total)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.total))]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "inline-link",
                    attrs: {
                      disabled: _vm.currentPage == _vm.total,
                      href: _vm.url
                    },
                    on: {
                      click: function($event) {
                        return _vm.setPage(+_vm.currentPage + 1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "oc-icon16 ico-arrow-right" })]
                )
              ])
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28704c5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28704c5d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/Pagination.vue
// module id = 169
// module chunks = 1